export type NoIntegrationsVersion = 'nodata' | 'cpi' | 'default'

interface NoIntegrationsStateInput {
  hasResults: boolean
  hasConfiguredDataSources: boolean
  hasCpiOptions: boolean
  /** True while a filter or a search term is narrowing the results. */
  searchActive: boolean
}

/**
 * Which NoIntegrations variant, if any, the Insights page renders in place of its list.
 * Those variants replace the FiltersToolbar, so the header's Filters button resolves the
 * same answer — deciding the two separately is what let a filtered-empty result render
 * the "activate a CPI" dead end with no filters on screen and no way back to them.
 *
 * `hasCpiOptions` is derived from the current result set, so it only carries the meaning
 * "this account has no CPIs activated" while nothing is narrowing the search.
 */
export function resolveNoIntegrationsVersion({
  hasResults,
  hasConfiguredDataSources,
  hasCpiOptions,
  searchActive
}: NoIntegrationsStateInput): NoIntegrationsVersion | null {
  if (hasResults) return null
  if (!hasConfiguredDataSources) return hasCpiOptions ? 'default' : 'nodata'

  return !hasCpiOptions && !searchActive ? 'cpi' : null
}
